import { render } from "./HorseCoveringHistoryTab.vue?vue&type=template&id=3f625f51"
import script from "./HorseCoveringHistoryTab.vue?vue&type=script&lang=js"
export * from "./HorseCoveringHistoryTab.vue?vue&type=script&lang=js"

import "./HorseCoveringHistoryTab.vue?vue&type=style&index=0&id=3f625f51&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__